import { styleOverrides } from "./styleOverrides";

const MuiTableCell = {
  styleOverrides,
};

export { MuiTableCell };
